import { useEffect } from 'react';

import { Checkbox } from '@frontend/components';

import { useTableContext } from '../utils/TableContext';
import {
  useSelectionContext,
  getNestedChildKeysFromDataObject,
  selectChildren,
  selectRange,
} from '../utils/selectHelpers';

/**
 * @deprecated use TableV2 and its subcomponents from '@frontend/components' instead.
 */
const SelectionCheckbox = ({ record, isMainParent, isDisabled }) => {
  const { data } = useTableContext();

  const { selected, onSelect, lastSelected, setLastSelected, shiftPressed } =
    useSelectionContext();

  let mixed = false;
  let empty = false;
  let full = false;

  if (record.children != null) {
    // Get the child keys not including our own key.
    const childKeys = getNestedChildKeysFromDataObject(record).filter(
      (el) => el !== record.key,
    );

    // Count the number of occurrences of child keys in selected to make judgments about our state.
    let occurrences = 0;
    childKeys.forEach((childKey) => {
      if (selected?.includes(childKey)) {
        occurrences += 1;
      }
    });

    mixed = occurrences >= 1 && occurrences < childKeys.length;
    empty = occurrences === 0;
    full = occurrences === childKeys.length && !empty;
  }

  useEffect(() => {
    if (mixed && selected?.includes(record.key)) {
      onSelect(selected?.filter((el) => el != record.key));
    }

    if (empty && selected?.includes(record.key)) {
      onSelect(selected?.filter((el) => el != record.key));
    }

    if (full && !selected?.includes(record.key)) {
      onSelect([...selected, record.key]);
    }
  }, [empty, full, mixed, onSelect, record, selected]);

  return (
    <Checkbox
      value={record.key}
      isIndeterminate={mixed}
      isDisabled={isDisabled}
      onChange={() => {
        // If we're pressing shift and have previously selected a checkbox,
        if (
          shiftPressed &&
          lastSelected != null &&
          lastSelected !== record.key
        ) {
          // Perform selection between a range...
          // ... where this checkbox's child selection is handled by selectRange.
          selectRange(
            data,
            selected,
            onSelect,
            lastSelected,
            record,
            mixed,
            isMainParent,
          );
        }
        // If we're not pressing shift...
        // ...or are pressing shift but haven't selected anything before...
        // ...and we have children...
        else if (record.children != null) {
          // Recursively select the children.
          selectChildren(
            data,
            record.key,
            mixed,
            selected,
            onSelect,
            isMainParent,
          );
        }
        // Set our last selected value after we've already dealt with any kind of shift selecting.
        setLastSelected(record.key);
      }}
    />
  );
};
export default SelectionCheckbox;
